import {inject, observer} from 'mobx-react';
import './index.scss';
@inject(({store}) => ({
    showRules: store.showRules,
    toggleShowRules: store.toggleShowRules,
    ymbj: store.ymbj,
    isOppo: store.isOppo
}))
@observer
class Rules extends React.Component {
    render() {
        const {showRules, toggleShowRules, ymbj = {}, isOppo} = this.props;
        let {headInfo = {}, oppoHeadInfo = {}} = ymbj;
        if(isOppo) {
            headInfo = oppoHeadInfo;
        }
        const {activityRules} = headInfo;
        if(!showRules) return null;
        return(
            <div className="rules-modal">
                <div className="rules-content">
                    <div className="rules-tit">活动规则</div>
                    <div className="rules-detail">
                        <div className="rules-item">
                            <div className="content">{activityRules}</div>
                        </div>

                    </div>
                    <div className="close yo-ico" onClick={() => {
                        toggleShowRules('showRules');
                    }}></div>
                </div>

            </div>
        );
    }
}

export default Rules;